export class HighLowPlayer {
    constructor(name, lives) {
        this.eliminated = false;
        this.lastScore = null;
        this.lastResult = '';
        this.name = name;
        this.lives = lives;
    }
}
export class HighLowHistoryEvent {
    constructor(playerIndex, score, allDartsScored, previousHighTarget, previousLowTarget, previousLives, previousLastScore, previousLastResult) {
        this.playerIndex = playerIndex;
        this.score = score;
        this.allDartsScored = allDartsScored;
        this.previousHighTarget = previousHighTarget;
        this.previousLowTarget = previousLowTarget;
        this.previousLives = previousLives;
        this.previousLastScore = previousLastScore;
        this.previousLastResult = previousLastResult;
    }
}
